module.exports = __webpack_public_path__ + "img/historico.dc5546d0.svg";